



















import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { LibraryMixin } from '@/mixins'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
import { waitForMinimumDelay } from '@/helpers/date'
import { spawn, Thread, Worker } from 'threads'

@Component({})
export default class TracksNotInPlaylist extends Mixins(LibraryMixin) {
  @Prop()
  tracks: Track[]

  amount: number = 0
  scanned: boolean = false
  loading: boolean = false
  results: Track[] = []

  reset() {
    this.scanned = false
    this.results = []
  }

  async scan() {
    if (this.loading || this.scanned || !this.library) return

    this.loading = true

    const startTime = new Date()

    const worker = await spawn(new Worker('@/helpers/features/healthchecks'))

    const result = await worker.findTracksInNPlaylists(this.library.tracks, this.$store.getters['library/playlistsFlat'], this.amount)

    this.results = result.tracks

    await Thread.terminate(worker)

    await waitForMinimumDelay(startTime)

    this.loading = false
    this.scanned = true

    this.$emit('input', this.results)
    this.$emit('text', result.text)

    window.addUsageStat(USAGE_STAT_FEATURES.HealthChecks, 'tracks without playlist', 'scan')
  }

  showTracks() {
    this.$emit('showTracks')
  }
}
